export const COMPANY_INFO = {
  name: "Beyond Ambition Limited",
  alternateName: "Beyond Ambition",
  phone: "+64 27 296 9776",
  phoneFormatted: "+64 27 296 9776",
  phoneLink: "tel:+64272969776",
  whatsapp: "+64 27 296 9776",
  whatsappLink: "https://wa.me/64272969776",
  email: "solutions@beyondambitionlimited.com",
  github: "https://github.com/daniyal-fullstack-engineer",
  githubRepo: "https://github.com/daniyal-fullstack-engineer/beyond-ambition",
  linkedin: "https://www.linkedin.com/company/beyond-ambition-limited",
  clutch: "https://clutch.co/profile/beyond-ambition",
  goodfirms: "https://www.goodfirms.co/company/beyond-ambition",
  address: {
    streetAddress: "41B White Swan Road, Mount Roskill",
    addressLocality: "Auckland",
    addressRegion: "Auckland",
    postalCode: "1041",
    addressCountry: "NZ"
  },
  addressFormatted: "41B White Swan Road, Mount Roskill, Auckland 1041, New Zealand",
  addressShort: "Auckland, New Zealand",
  addressLine1: "41B White Swan Road, Mount Roskill",
  addressLine2: "Auckland 1041, New Zealand",
  nzbn: "9429053304834",
  nzbnUrl: "https://www.nzbn.govt.nz/mynzbn/nzbndetails/9429053304834",
  googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=41B+White+Swan+Road,+Mount+Roskill,+Auckland+1041,+New+Zealand",
  websiteUrl: "https://beyondambitionlimited.com"
};
